export default __webpack_public_path__ + "static/benefit3-d706c169f2c6ae380d57c0e7ac694066.svg";